import LDClientSingleton from './ldClientSingleton';

export const getFlagValue = (flagKey: string) => {
  const ldClient = LDClientSingleton.getInstance();
  if (!ldClient) {
    throw new Error('LD Client is not initialized');
  }
  return ldClient.variation(flagKey, false);
};

const flagCache = new Map<string, boolean>();
let changeListenerRegistered = false;

// Clear the cache whenever LD pushes new flag values (including on context/identify changes)
// so a runtime flag flip still takes effect on the next read.
const ensureChangeListener = () => {
  if (changeListenerRegistered) return;
  LDClientSingleton.getInstance()?.on('change', () => flagCache.clear());
  changeListenerRegistered = true;
};

// when `ldClient.variation()` is called (through `getFlagValue()`), even though it doesn't trigger a full evaluation if the flag value hasn't changed,
// it'll trigger the /events/bulk req for sending analytics to LD. For some of the hotter paths this means tons and tons of unnecessary requests.
// if a certain flag is accessed very frequently, this method can be used instead of `getFlagValue()` to avoid the unnecessary requests.
export const getCachedFlagValue = (flagKey: string): boolean => {
  ensureChangeListener();
  if (!flagCache.has(flagKey)) {
    flagCache.set(flagKey, Boolean(getFlagValue(flagKey)));
  }
  return flagCache.get(flagKey) as boolean;
};
